'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var ListItem = require('@material-ui/core/ListItem');
var ListItemAvatar = require('@material-ui/core/ListItemAvatar');
var ListItemText = require('@material-ui/core/ListItemText');
var styles = require('@material-ui/styles');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ListItem__default = /*#__PURE__*/_interopDefaultLegacy(ListItem);
var ListItemAvatar__default = /*#__PURE__*/_interopDefaultLegacy(ListItemAvatar);
var ListItemText__default = /*#__PURE__*/_interopDefaultLegacy(ListItemText);

var useStyles = styles.makeStyles(theme => ({
  /** Styles applied to the `primary` class for the `ListItemText` element. */
  primary: _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, theme.typography.h6), {}, {
    color: theme.palette.text.secondary
  })
}));
/**
 * Title for a menu panel.
 */

var MenuPanelTitle = _ref => {
  var {
    avatar,
    subtitle,
    title
  } = _ref;
  var classes = useStyles();
  return /*#__PURE__*/React__default['default'].createElement(ListItem__default['default'], null, !!avatar && /*#__PURE__*/React__default['default'].createElement(ListItemAvatar__default['default'], null, avatar), /*#__PURE__*/React__default['default'].createElement(ListItemText__default['default'], {
    primary: title,
    secondary: subtitle,
    classes: {
      primary: classes.primary,
      secondary: classes.secondary
    }
  }));
};
MenuPanelTitle.propTypes = {
  /** Optional avatar to display. */
  avatar: index.node,

  /** The value of the subtitle string. */
  subtitle: index.string,

  /** The value of the title string. */
  title: index.string.isRequired
};

exports.MenuPanelTitle = MenuPanelTitle;
exports.default = MenuPanelTitle;
